// 航点模式
export default {
    normal: 'Normal',
    hover: 'Hover',
    land: 'Land',
    returnStarting: 'Return to Starting',
    returnHome: 'Return to Home',
    parkingInteraction: 'Parking interaction',
}